export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/48c12bd24198a2eababf6dc2ec7797be.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40 z-0"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center space-x-2 bg-teal-600/20 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-white text-xs font-semibold uppercase tracking-wider">Secure Connection</span>
            </div>

            <h1 className="text-6xl lg:text-7xl xl:text-8xl font-bold text-white mb-6 leading-tight">
              Your Digital<br />
              <span className="bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">
                Privacy
              </span><br />
              Starts Here
            </h1>

            <p className="text-lg lg:text-xl text-gray-200 mb-12 max-w-xl mx-auto lg:mx-0">
              Enterprise-grade VPN protection for everyone. Secure your online presence with military-level encryption.
            </p>

            <button
              onClick={() => scrollToSection('pricing')}
              className="group inline-flex items-center space-x-3 bg-teal-600 hover:bg-teal-700 text-white px-10 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:scale-105 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              <span>Get Protected Now</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>

            <p className="text-sm text-gray-300 mt-4">No credit card required</p>
          </div>

          <div className="hidden lg:flex justify-center items-center">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-teal-500/30 to-emerald-500/30 blur-3xl rounded-full"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20VPN%20application%20interface%20with%20connection%20status%2C%20security%20shield%20icon%2C%20and%20network%20activity%20indicators%2C%20floating%20at%2015%20degree%20angle%2C%20clean%20UI%20design%20with%20teal%20and%20white%20colors%2C%20professional%203D%20render%2C%20transparent%20background%2C%20high%20quality%20product%20visualization&width=600&height=800&seq=hero-phone-001&orientation=portrait"
                alt="VPN App Interface"
                className="relative w-80 xl:w-96 drop-shadow-2xl transform rotate-6 hover:rotate-3 transition-transform duration-500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
